// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global table styling - Based on Equity table styling */
/* This ensures all tables have consistent base styling */
table {
  border-collapse: collapse;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
  width: 100%;
}th {
  padding: 0.625rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  transition: background-color 0.2s;
  font-variant-numeric: tabular-nums;
}td {
  padding: 0.625rem 0.75rem;
  color: #1a1a1a;
  white-space: nowrap;
  position: relative;
  font-variant-numeric: tabular-nums;
  text-align: left;
}/* Component-specific tables can override these defaults */
/* Equity, OpenPositions, Trades2, etc. will use their own specific classes */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA,yDAAyD;AACzD,yDAAyD;AACzD;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;AACb,CAAC;EACC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;AACpC,CAAC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB,CAAC,0DAA0D;AAC3D,6EAA6E","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global table styling - Based on Equity table styling */\n/* This ensures all tables have consistent base styling */\ntable {\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n  font-variant-numeric: tabular-nums;\n  width: 100%;\n}th {\n  padding: 0.625rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n  font-variant-numeric: tabular-nums;\n}td {\n  padding: 0.625rem 0.75rem;\n  color: #1a1a1a;\n  white-space: nowrap;\n  position: relative;\n  font-variant-numeric: tabular-nums;\n  text-align: left;\n}/* Component-specific tables can override these defaults */\n/* Equity, OpenPositions, Trades2, etc. will use their own specific classes */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
